import { render, staticRenderFns } from "./Parcel.vue?vue&type=template&id=7a01815a&scoped=true&"
import script from "./Parcel.vue?vue&type=script&lang=ts&"
export * from "./Parcel.vue?vue&type=script&lang=ts&"
import style0 from "./Parcel.vue?vue&type=style&index=0&id=7a01815a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a01815a",
  null
  
)

export default component.exports